import './polyfills-leaflet';
import { createCustomElement } from '@angular/elements';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { VdoMapClusterIconComponent } from '@ui/components/maps/vdo-map-cluster-icon/vdo-map-cluster-icon.component';
import { VdoMapIconMarkerComponent } from '@ui/components/maps/vdo-map-icon-marker/vdo-map-icon-marker.component';
import { VdoMapMakerDetailsComponent } from '@ui/components/maps/vdo-map-maker-details/vdo-map-maker-details.component';
import { VdoMapMarkerIconComponent } from '@ui/components/maps/vdo-map-marker-icon/vdo-map-marker-icon.component';
import { VdoMapTooltipComponent } from '@ui/components/maps/vdo-map-tooltip/vdo-map-tooltip.component';

bootstrapApplication(AppComponent, appConfig)
  .then(app => {
    const ClusterMarker = createCustomElement(VdoMapClusterIconComponent, {
      injector: app.injector,
    });

    const vdoMapMakerDetails = createCustomElement(VdoMapMakerDetailsComponent, {
      injector: app.injector,
    });

    customElements.define('cluster-icon', ClusterMarker);
    customElements.define('custom-vdo-map-maker-details', vdoMapMakerDetails);

    const VdoMapMarkerIcon = createCustomElement(VdoMapMarkerIconComponent, {
      injector: app.injector,
    });

    customElements.define('vdo-map-marker-icon', VdoMapMarkerIcon);

    const VdoMapTooltipCE = createCustomElement(VdoMapTooltipComponent, {
      injector: app.injector,
    });

    customElements.define('vdo-map-tooltip', VdoMapTooltipCE);

    const VdoMapIconMarker = createCustomElement(VdoMapIconMarkerComponent, {
      injector: app.injector,
    });
    customElements.define('vdo-map-icon-marker', VdoMapIconMarker);
  })
  .catch(err => console.error(err));
